$( window ).resize(function() {
  $(".scroller").height($(window).height());
});

$(document).ready(function(){  
    
    var rolou = 0;
    
     $(".scroller").height($(window).height());
    
     $(".scroller").mCustomScrollbar({
         theme: "dark-thick",
         scrollbarPosition: "inside",
         mouseWheel:{ scrollAmount: 300 },
         callbacks:{
            whileScrolling :function(){
                rolou = this.mcs.top;
                if(rolou < -200){
                    $(".navbar-brand").addClass("scroll2");
                }else if(rolou > -200){
                    $(".navbar-brand").removeClass("scroll2");
                }
            }
         }
         
     });
    
    //$("#navbar.main-navbar").addClass("pick bg-white");

     $window = $(window);
    //Captura cada elemento section com o data-type "background"
    $('section[data-type="background"]').each(function(){
        var $scroll = $(this);   
            //Captura o evento scroll do navegador e modifica o backgroundPosition de acordo com seu deslocamento.            
            $(window).scroll(function() {
                var yPos = -($window.scrollTop() / $scroll.data('speed')); 
                var coords = '10% '+ yPos + 'px';
                $scroll.css({ backgroundPosition: coords });    
            });
    }); 
    
    $('.carousel').carousel();    
    $('.main-navbar > ul > li.dropdown').on({
        mouseenter: function(){
            $(this).addClass('open');
            $(this).children("a").attr('aria-expanded', "true");
        },
        mouseleave: function(){
            $(this).removeClass('open');
            $(this).children("a").attr('aria-expanded', "false");
        }
    });
    
    $('#link-search').on({
      click: function(){
        $(".form-inline, .search-box").addClass("open");
        $(this).hide();
        $("#restrict-area").hide();
      }
    });
    
    $('#search-buutton').on({
      click: function(){
        $(".form-inline, .search-box").removeClass("open");
        setTimeout( function(){$("#link-search, #restrict-area").show()}, 350 );
      }
    });
    
   /* setTimeout(function(){
         $(".gm-style > div > div:first, .gm-style > div > div:nth-child(4)").css({
              left: "100px",
              top: "-61px"
            });
    },3000)
    */
    
});

